<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.name }}</p>
      <small>Available</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img key="onlineImg" :src="getUrlOfFile(activeUserInfo.image)" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block object-cover" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li>
            <router-link to="/profile" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Profile</span>
            </router-link>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import {getUrlOfFile} from '@/utils/helpers'
export default {
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser.admin
    }
  },
  methods: {
    getUrlOfFile(file) {
      return getUrlOfFile(file)
    },
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login').catch(() => {})
      })
    },
  }
}
</script>
